import React from "react";
import { useAuth } from "app/providers/authContext";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

const LogoutIcon = () => {
  const { logout } = useAuth();

  return (
    <Tooltip title="Cerrar sesión">
      <IconButton color="error" onClick={logout}>
        <Icon>logout</Icon>
      </IconButton>
    </Tooltip>
  );
};

export default LogoutIcon;
